import React, { memo } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import styles from './Cells.module.css';
import Langs from '../../../app/lang/langs';

/**
 * Small medical symbol shown on a planning day when the collab has a medical
 * visit scheduled on that date (medical_visits.planned_visit_date).
 * Deliberately date-only: it never surfaces the visit type or conclusion, which
 * stay behind the medicalVisits scope.
 */
export const MedicalVisitBadge = memo(function MedicalVisitBadge({ visit }) {

    if (!visit) return null

    const renderTooltip = (props) => (
        <div className={styles.tooltip} id={props.name} {...props}>
            <Langs str="MEDICAL_VISIT_PLANNED_TOOLTIP" />
        </div>
    )

    return (
        <OverlayTrigger
            placement="top"
            delay={{ show: 300, hide: 100 }}
            overlay={renderTooltip}>
            <span className={styles.medicalVisitBadge}>
                <MedicalServicesIcon style={{ fontSize: 13 }} />
            </span>
        </OverlayTrigger>
    )
})
